<!-- 予約内容の表示を行うコンポーネント -->
<template>
  <div
    class="list-item__book"
    :class="[
      reservation.status == 'CANCELED' || reservation.status == 'CANCELLED'
        ? 'used'
        : '',
    ]"
    @click="
      [
        reservation.status == 'CANCELED' || reservation.status == 'CANCELLED'
          ? ''
          : ncModeDemand(reservation.id, service_id)
      ]
    "
  >
    <div class="index-content-left">
      <img
        class="list-item__thumbnail"
        :src="require(`@/assets/img/material/ai.png`)"
      />
    </div>
    <div class="index-content-center">
      <div class="list-item__title">
        {{ reservation.serviceName }}
      </div>
      <p class="demand-status">
        <a v-if="reservation.masterBookingserviceId == 1">{{ EbusStatus }}</a>
        <a v-if="reservation.masterBookingserviceId == 2">{{ ShotlStatus }}</a>
      </p>

      <div class="list-item__departure">
        <a v-if="reservation.masterBookingserviceId == 1">{{
          displayUsageStartDatetime(reservation.latestEstimatePickUpTime)
        }}</a>
        <a
          v-else-if="
            reservation.masterBookingserviceId == 2 &&
            reservation.predicted_times.predicted_pickup_time
          "
          >{{
            displayUsageStartDatetime(
              reservation.predicted_times.predicted_pickup_time * 1000
            )
          }}</a
        >
        <a v-else-if="reservation.masterBookingserviceId == 2">{{
          displayUsageStartDatetime(
            reservation.user_expected_pickup_time * 1000
          )
        }}</a>

        出発<br />
      </div>
      <div class="list-item__date">
        <div class="list-item__passenger">
          <span class="list-item__header">
            {{ $t("common.passengers") }}
          </span>
          <a v-if="reservation.masterBookingserviceId == 1">
            <a v-if="reservation.seatCount.adult">{{
              `おとな${reservation.seatCount.adult}名 `
            }}</a>
            <a v-if="reservation.seatCount.child">{{
              `こども${reservation.seatCount.child}名 `
            }}</a>
            <a v-if="reservation.seatCount.infant">{{
              `幼児${reservation.seatCount.infant}名`
            }}</a>
          </a>
          <a v-else-if="reservation.masterBookingserviceId == 2">
            <a v-if="reservation.seat_count.adult">{{
              `おとな${reservation.seat_count.adult}名 `
            }}</a>
            <a v-if="reservation.seat_count.child">{{
              `こども${reservation.seat_count.child}名 `
            }}</a>
            <a v-if="reservation.seat_count.infant">{{
              `幼児${reservation.seat_count.infant}名`
            }}</a>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ItemIndexDemandReservation",

  props: {
    reservation: {
      type: Object,
      required: true,
    },
    service_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // フォーマット処理
    displayUsageStartDatetime(time) {
      return this.$moment(new Date(time)).format("YYYY/MM/DD HH:mm");
    },
    ncModeDemand(reservation_id, service_id){
      nativeHandlerService.demand.ncModeDemand(reservation_id, service_id)
    }
  },
  computed: {
    EbusStatus() {
      switch (this.reservation.status) {
        case "ASSIGNED":
          return "車両割り当て済";
        case "PICKING_UP":
          return "迎車中";
        case "BOARDING":
          return "乗車中";
        case "FINISHED":
          return "降車済";
        case "CANCELED":
          return "キャンセル済";
        case "DENIED":
          return "拒否";
        case "DECLINED":
          return "仮予約取消済";
        case "PENDING":
          return "保留";
      }
      return true;
    },
    ShotlStatus() {
      switch (this.reservation.status) {
        case "DRAFT":
          return "仮予約";
        case "SCHEDULED":
          return "予約受付済";
        case "DRIVER_LAUNCHED":
          return "迎車中";
        case "USER_LAUNCHED":
          return "迎車中";
        case "ONBOARD":
          return "乗車中";
        case "FINISHED":
          return "降車済";
        case "CANCELLED":
          return "キャンセル";
        case "SYSTEM_CANCELLED":
          return "キャンセル";
        case "EARLYDROPOFF":
          return "降車済";
        case "NOSHOW":
          return "不在の為キャンセル";
        default:
          return "その他";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.demand-status {
  position: absolute;
  top: 10%;
  right: 2%;
  font-weight: bold;
  color: #787878;
  font-size: 3vw;
}
.list-item__book {
  background: white;
  border: 1px solid #e0e0e0;
  margin-bottom: 2vw;
  border-radius: 5px;
}

.used {
  background: #f0f0f0;
}

.index-content-left {
  float: left;
  width: 85px;
  max-width: 22.9vw;
}

.list-item__thumbnail {
  width: 100%;
  border-radius: 5px 0 0 5px;
  background-size: cover;
}
@media screen and (min-width: 421px) {
  .index-content-left {
    width: 20vw;
  }

  .list-item__thumbnail {
    width: 20vw;
  }
}

.cb {
  clear: both;
}

.index-content-center {
  overflow: hidden;
  width: 73%;
  position: relative;
  height: calc(100vw * (23 / 100));
  padding-left: 2%;
  float: left;
}
@media screen and (min-width: 421px) {
  .index-content-center {
    height: 20vw;
  }
}

.index-content-right {
  position: relative;
  top: 30%;
}

.list-item__title {
  font-size: 3.5vw;
  position: absolute;
  top: 18%;
  overflow: hidden;
  font-weight: bold;
}
.list-item__departure {
  font-size: 3.5vw;
  position: absolute;
  top: 42%;
  overflow: hidden;
  font-weight: bold;
}

.list-item__date {
  font-size: 2vw;
  position: absolute;
  top: 70%;
  color: #777777;
  font-weight: bold;
  width: 100%;
}

.list-item__passenger {
  font-size: 2vw;
  position: absolute;
  top: 75%;
  color: #777777;
  font-weight: bold;
  width: 100%;
}

.list-item__header {
  font-size: 3vw;
  width: 20%;
  display: inline-block;
}

.list-item__ticket {
  height: 12vw;
  border-bottom: 1px dashed #d7d7d7;
}

.list-item__ticket .used {
  background: red;
  height: 12vw;
  border-bottom: 1px dashed #d7d7d7;
}

.list-item__ticket:last-child {
  border-bottom: none;
}

.index-ticket-left {
  float: left;
  width: 77vw;
  font-size: 3vw;
  overflow: hidden;
  padding: 0vw 2vw;
  height: 100%;
}

.index-ticket-right {
  height: 12vw;
  width: calc(23vw - 4vw - 1px);
  float: left;
  border-left: 1px dashed #d7d7d7;
}

.used {
  background: #f0f0f0;
}

.button_valid {
  color: white;
  background: #f76666;
}

.button_used {
  background: #e0e0e0;
}

.s_button {
  font-size: 0.8rem;
}

.button__text {
  padding-top: 4vw;
  width: 100%;
  text-align: center;
}
</style>
